import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Mail } from "lucide-react";
import { BRAND } from "../mock";

export default function BookCTA() {
  return (
    <section id="book" className="relative bg-[var(--lc-ink)] text-[var(--lc-cream)] py-20 lg:py-28 overflow-hidden">
      <div className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-[var(--lc-moss)] opacity-15 blur-3xl pointer-events-none" />
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow text-[var(--lc-sand)] mb-5">Free 1:1 Consultation</div>
            <h2 className="font-serif-display text-[clamp(36px,6vw,84px)] leading-[1] font-light">
              Let’s build your custom <span className="italic">transformation.</span>
            </h2>
            <p className="mt-8 max-w-xl text-[15px] leading-relaxed text-white/75">
              Book a 30-minute discovery call. We'll review your goals,
              schedule and budget — and recommend the right pillars to
              prioritize. No commitment required.
            </p>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <Link
              to="/book"
              className="group inline-flex items-center gap-3 bg-[var(--lc-moss)] hover:bg-[var(--lc-sand)] hover:text-[var(--lc-ink)] text-white px-8 py-4 text-[12px] font-bold tracking-[0.18em] uppercase transition-colors"
            >
              Book Free Call <ArrowUpRight className="h-4 w-4" />
            </Link>
            <div className="mt-6 flex flex-col sm:flex-row lg:justify-end gap-3 text-sm">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 text-white/85 hover:text-[var(--lc-sand)] transition-colors"
              >
                <Instagram className="h-4 w-4" /> {BRAND.instagramHandle}
              </a>
              <a
                href={`mailto:${BRAND.email}`}
                className="inline-flex items-center gap-2 text-white/85 hover:text-[var(--lc-sand)] transition-colors"
              >
                <Mail className="h-4 w-4" /> {BRAND.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
